import { FieldError } from "react-hook-form";
import { InputFieldError } from "../forms/input";

export const FormErrorMessage = ({ error }: { error: FieldError }) => {
  const { message, root, types } = error;

  if (types) {
    return Object.entries(types).map(([type, message]) => (
      <InputFieldError key={type} error={`${message}`} />
    ));
  }

  if (message) {
    return <InputFieldError error={message} />;
  }

  if (root) {
    return <FormErrorMessage error={root} />;
  }

  return null;
};
